import QueryString, { parse } from 'qs';
import SkinStore from '../loginPool/skinStore';
import { observable, action, runInAction } from "mobx";
import * as LoginAPI from "../../../api/login";
import { loginParamsType, OneKeyLoginConfig } from "./type";
import { MDialog } from '@weapp/ui';
import { weappSDK, getLabel } from '@weapp/utils';
import {
  setCookie,
  getQueryString,
  inApp,
  mainHost,
  cloneObj,
  setTokenStorage,
  setStorage,
  encryptRsa,
  isIos,
  getCookie,
  isEcologyEnv,
  dealImageUrl,
  setAreaCodeStorage, setAccountStorage, setAutoPswStorage,
  isE10Self, isCustomLoginPath, getCustomLoginKey
} from '../../../utils';
import { LOCATION_ORIGN, publicUrl, publicUrlapi } from "../../../constants";
import { queryLogo } from '../../../api/pc/login';
const { toast, prompt } = MDialog;
let andriodApiNum = 0;

export class mLoginStore {
  @observable loginLoading = false;
  @observable dialogadviceVisible = false;
  @observable onLoginError: any = null;
  @observable qysFrameSrc: string = '';//契约锁认证
  @observable safeAccountLogin = []; //安全设置系统登录方式
  qysParams: any = null;
  qysTimer: any = null;
  onQysChecking: any = false;
  @observable fromQys = false;
  listenVisible_added = false;
  app_qysQueryParams: any = null;
  app_qysLoginObj: any = null;

  //本机号码一键登录
  phoneOnKeyLoginDeviceBindToken = "";
  bindDeviceCallback: any = null;
  @observable oneKeyLoginConfig: OneKeyLoginConfig = new OneKeyLoginConfig();
  @observable bindMobileToken = "";   //一键登录绑定账号token


  @action
  setQysFrameSrc = (value: string) => {
    this.qysFrameSrc = value;
  }
  @action
  changeDialogadviceVisible = () => {
    this.dialogadviceVisible = !this.dialogadviceVisible
  }
  @action
  init = (ev: any) => {
    this.onLoginError = ev;
    this.listenVisible();
  }
  @action
  listenVisible = () => {

    if (inApp()) {
      weappSDK.checkApi('listenVisible').then(() => {
        weappSDK.exec('listenVisible', {
          success: () => { },
          fail: () => { },
          callback: (res: any) => {
            if (res?.visible && this.onQysChecking) {
              this.appQysCheckOnece(this.app_qysQueryParams, this.app_qysQueryParams)
            }
          },
        })
      })
    }
  }
  /**
   *
   * @param etoken 轮询请求etoken判断登录状态
   */
  @action
  qysCheckLogin = (queryParams: any, loginObj: any) => {
    this.qysTimer = setInterval(() => {
      this.appQysCheckOnece(queryParams, loginObj)
    }, 1000)
  }
  @action
  appQysCheckOnece = (queryParams: any, loginObj: any) => {

    LoginAPI.qysCheckLogin(queryParams).then((result: any) => {

      if (result.code === 200) {
        //拿到登录信息
        if (result.data?.loginData) {
          clearInterval(this.qysTimer);
          sessionStorage.removeItem('passport_qys_faild');
          this.loginCallback(result.data?.loginData, loginObj, queryParams?.oneKeyLogin);
        } else {
          // runInAction(() => {
          //   if (this.fromQys) {
          //     this.onQysChecking = false;
          //     this.loginLoading = false;
          //     clearInterval(this.qysTimer);
          //   }
          // })
        }
      } else {
        // runInAction(() => {
        //   if (this.fromQys) {
        //     this.onQysChecking = false;
        //     this.loginLoading = false;
        //   }
        // })
        clearInterval(this.qysTimer);
        sessionStorage.setItem('passport_qys_faild', '1');
        if (result.data?.msg) {
          toast({
            content: getLabel(result.data?.i18nId, result.data?.msg)
          })
        }

      }
    })
  }
  @action
  adviceThirdBind = (obj: any) => {
    this.loginLoading = true;
    if (this.phoneOnKeyLoginDeviceBindToken) { //存在手机号码一键登录设备绑定token
      obj.deviceBindToken = this.phoneOnKeyLoginDeviceBindToken;
    }
    LoginAPI.adviceThirdBind(obj).then((result: any) => {
      runInAction(() => {
        if ("0" == String(result.returnCode)) {
          this.loginLoading = false;
          this.dialogadviceVisible = false;
          if (this.phoneOnKeyLoginDeviceBindToken) { //app一键登录绑定设备过来
            this.phoneOnKeyLoginDeviceBindToken = "";
            this.bindDeviceCallback?.();
            this.bindDeviceCallback = null;
            // this.phoneNumberOneKeyLogin(this.phoneOnKeyLoginLoginData);
          } else {  //其他三方登录绑定设备过来
            weappSDK.register('getThirdAccountInfo', (params: any) => {
              weappSDK.customSDK.invoke('getThirdAccountInfo', params)
            })
            weappSDK.exec('getThirdAccountInfo', {
              thirdType: window.sessionStorage.getItem('passport_thirdlogin_Type'),
            }).then((res: any) => {
              console.log(res);
              let type = "1";
              if (res.openId != "") {
                if ("1" == window.sessionStorage.getItem('passport_thirdlogin_thirdType')) {
                  type = "qq";
                } else if ("2" == window.sessionStorage.getItem('passport_thirdlogin_thirdType')) {
                  type = "weibo";
                } else if ("3" == window.sessionStorage.getItem('passport_thirdlogin_thirdType')) {
                  type = "wechat";
                } else if ("4" == window.sessionStorage.getItem('passport_thirdlogin_thirdType')) {
                  type = "apple";
                }
                weappSDK.customSDK.invoke("getClientInfo", {
                  success: (res1: any) => {
                    const params = {
                      nickname: res.nickName,
                      openId: res.openId,
                      thirdType: type,
                      version: res1.clientVersion,
                      secondImei: res1.deviceId2,
                      imei: res1.deviceId,
                    }
                    LoginAPI.clearWeappCookie().then(() => {
                      LoginAPI.thirdteamsLogin(params).then((result: any) => {
                        window.sessionStorage.setItem('thirdParams', JSON.stringify(params));
                        if (result.ETEAMSID != null && result.ETEAMSID != "") {
                          let host = window.location.hostname;
                          let domain = host.substr(host.indexOf(".") + 1);


                          if (result.employeeid) {
                            if (inApp()) {
                              //   weappSDK.invoke("clearWebCaches", {
                              //     success: (res:any)=> {}
                              // });
                              weappSDK.register('login', (params: any) => {
                                weappSDK.customSDK.invoke('login', params)
                              })
                              let loginParams = {
                                loginkey: result.ETEAMSID,
                                tenantid: result.tenantkey,
                                userid: result.employeeid,
                                username: result.username,
                                activeLoginType: SkinStore?.activeLoginType,
                                password: "",
                                langid: result.langType,
                                cid: result.cid,
                                into: 1,
                              };
                              if (window.ecode_passportAppLoginGetParams && typeof window.ecode_passportAppLoginGetParams === "function") {
                                loginParams = window.ecode_passportAppLoginGetParams() || loginParams;
                              }
                              weappSDK.exec('login', loginParams).then((res: any) => {
                                console.log(res)
                              })
                            } else {
                              window.location.href = `${mainHost()}${publicUrl}`;
                            }
                          } else {
                            window.sessionStorage.setItem('passport_sign_account', result?.account || '');
                            if (isEcologyEnv()) {
                              this.ecToEteams(); return;
                            }
                            this.toCreateTeams()
                          }

                          // setCookie('ETEAMSID', result.ETEAMSID);
                          // setCookie('ETEAMSID', result.ETEAMSID, domain);
                        } else if (result.actionMsg.message != null && result.actionMsg.message != "") {
                          this.loginLoading = false;
                          toast({
                            content: result.message,
                            mask: false,
                            delay: 2000
                          });
                        }
                      }).catch((error) => {
                        console.log(error);
                      });
                    });
                  }
                })
              }
            }).catch((error: any) => {
              console.log(error);
            });
          }
        } else {
          this.loginLoading = false;
          this.dialogadviceVisible = false;
          if (result.message) {
            toast({
              content: result.message,
              mask: false,
              delay: 2000
            });
          } else if (result.actionMsg) {
            toast({
              content: result.actionMsg.message,
              mask: false,
              delay: 2000
            });
          }
        }

      })

    })
      .catch((error) => {
        console.log(error);
      });
  };

  @action
  bindAdvice = (obj: any) => {
    this.loginLoading = true;
    LoginAPI.adviceBind(obj).then((result: any) => {
      runInAction(() => {
        if ("0" == result.returnCode) {
          this.loginLoading = false;
          this.dialogadviceVisible = false;
          weappSDK.customSDK.invoke("getClientInfo", {
            success: (res: any) => {
              let appParams = {
                imei: res.deviceId,
                version: res.osVersion,
                secondImei: res.deviceId2,
                adviceInfo: res.clientModel,
                password: window.sessionStorage.getItem('passport_sign_psw'),
                username: window.sessionStorage.getItem('passport_sign_account'),
              }
              const loginObj = cloneObj(appParams);
              LoginAPI.clearWeappCookie().then(() => {
                LoginAPI.newLogin(appParams).then((res: any) => {
                  const result = res.data;
                  if ("true" == result.succeed && (result.ETEAMSID != null && result.ETEAMSID != "")) {
                    let host = window.location.hostname;
                    let domain = host.substr(host.indexOf(".") + 1);
                    // weappSDK.invoke("clearWebCaches", {
                    //   success: (res:any)=> {}
                    // });
                    // setCookie('ETEAMSID', result.ETEAMSID);
                    // setCookie('ETEAMSID', result.ETEAMSID, domain);
                    // LoginAPI.clearWeappCookie().then(() => {
                    weappSDK.register('login', (params: any) => {
                      weappSDK.customSDK.invoke('login', params)
                    });
                    weappSDK.exec('login', {
                      loginkey: result.ETEAMSID,
                      tenantid: result.tenantkey,
                      userid: result.employeeid,
                      username: result.username,
                      password: loginObj.password,
                      langid: result.langType,
                      cid: result.cid,
                      into: 1,
                    }).then((res: any) => {
                      console.log(res)
                    })
                    // })
                  } else {
                    this.loginLoading = false;
                    toast({
                      content: result.message,
                      mask: false,
                      delay: 2000
                    });
                  }
                });
              });
            }
          });
        } else {
          this.loginLoading = false;
          this.dialogadviceVisible = false;
          if (result.message) {
            toast({
              content: result.message,
              mask: false,
              delay: 2000
            });
          } else if (result.actionMsg) {
            toast({
              content: result.actionMsg.message,
              mask: false,
              delay: 2000
            });
          }

        }

      })

    })
      .catch((error) => {
        this.loginLoading = false;
        console.log(error);
      });
  };

  //h5 登录store
  @action
  getLogin = (loginParmas: loginParamsType) => {
    this.loginLoading = true;
    const loginObj = cloneObj(loginParmas);
    const errorHandle = (msg: string) => {
      runInAction(() => this.loginLoading = false)
      this.onLoginError?.();
      toast({ content: msg, mask: false, delay: 1000 });
    }
    loginParmas.passportCusLoginDomain = LOCATION_ORIGN;
    if (window.location.pathname.indexOf('/customlogin') > -1) {
      loginParmas.passportCusLoginPath = window.location.pathname.replace(publicUrl, '');
    }
    const loginRequst = () => {

      LoginAPI.clearWeappCookie().then(() => {
        LoginAPI.newLogin(loginParmas).then((response: any) => {
          if (response?.code === "20211217") {
            toast({
              content: response.msg
            })
            return
          }
          const result = response.data;

          if (response.code !== 200) return errorHandle(result.errorMsg.alreadyTranslate ? result.errorMsg.msg : getLabel(result.errorMsg.i18nId, result.errorMsg.msg));

          if (result?.authUrl) {
            runInAction(() => { this.loginLoading = false })
            this.app_qysQueryParams = {
              authId: result.authId,
              tenantKey: result.tenantKey
            };
            this.app_qysLoginObj = loginObj;
            //开始契约锁认证
            runInAction(() => {
              this.onQysChecking = true;
              if (inApp()) {
                weappSDK.customSDK.invoke("openLink", {
                  url: result.authUrl,
                  openType: 2,
                  success: () => {

                    // this.qysCheckLogin({
                    //   authId: result.authId,
                    //   tenantKey: result.tenantKey
                    // }, loginObj);
                    // this.listenVisible();
                  }
                });
              } else {
                this.qysCheckLogin({
                  authId: result.authId,
                  tenantKey: result.tenantKey
                }, loginObj);
                this.setQysFrameSrc(result.authUrl);
              }
            })
          } else if (result?.needPwdChange) {
            this.onQysChecking = false;
            this.checkResetPass(loginObj);
          } else {
            this.onQysChecking = false;
            this.loginCallback(result, loginObj);
          }
        }).catch((error) => {
          this.onQysChecking = false;
          console.log(error);
        });
      });
    }
    if (inApp()) {
      weappSDK.customSDK.invoke("getClientInfo", {
        inputName: loginParmas.username,
        success: (res: any) => {
          let appParams = {
            imei: res.deviceId,
            version: res.osVersion,
            secondImei: res.deviceId2,
            adviceInfo: res.clientModel
          }
          loginParmas['loginHardwareId'] = res.deviceId;
          loginParmas['loginLanguage'] = getCookie('langType') || '';
          loginParmas['loginDeviceSysVersion'] = res.osVersion;
          loginParmas['loginDeviceVersion'] = res.clientModel;
          loginParmas = { ...loginParmas, ...appParams };
          loginRequst();
        }

      })
    } else {
      loginRequst();
    }

  };

  @action
  checkResetPass = (loginObj: any) => {
    runInAction(() => {
      this.loginLoading = false;
    })
    //管理员重置密码强制用户修改
    let confirm: any;
    prompt({
      title: getLabel('154889', '请立即修改密码'),
      prompt: false,
      description: getLabel('154580', '您上次使用的是被管理员修改或重置的密码，请立即修改密码，以保障账号安全'),
      getInstance: (el: any) => {
        confirm = el;
      },
      footer: [{
        key: 'confirm',
        text: getLabel('93406', '确定'),
        type: 'primary',
        onPress: () => {
          let data = { password: loginObj.password };
          data = encryptRsa(data, 'password')
          sessionStorage.setItem("PASSPORT_RESETPASS_TRANS", data.password);
          if (inApp()) {
            const link = `${LOCATION_ORIGN}${publicUrl}/passport/resetpass?redirect=${encodeURIComponent(window.location.href)}&account=${loginObj.username}&password=${data.password}`;
            weappSDK.customSDK.invoke("openLink", {
              // url: link,
              url: link,
              openType: 2,
            });
            confirm?.onClose?.();
          } else {
            const link = `${publicUrl}/passport/resetpass?redirect=${encodeURIComponent(window.location.href)}&account=${loginObj.username}`;
            window.location.href = link;
          }
        }
      }]
    })
  }

  mobileLoginObj = {} as any;
  needBindDeviceCallback: any = null;
  @action
  phoneNumberOneKeyLogin = (params: any, needBindDeviceCallback?: Function, bindDeviceCallback?: Function, beforeChangeBindAccount?: Function) => {
    this.loginLoading = true;
    const errorHandle = (msg: string) => {
      runInAction(() => this.loginLoading = false)
      this.onLoginError?.();
      toast({ content: msg, mask: false, delay: 1000 });
    }
    this.mobileLoginObj = { username: params.username, password: params.password };
    this.needBindDeviceCallback = needBindDeviceCallback;
    this.bindDeviceCallback = bindDeviceCallback;
    LoginAPI.clearWeappCookie().then(() => {
      LoginAPI.phoneNumberOneKeyLogin({
        token: params.token,
        devType: params.devType,
        imei: params.imei,
      }).then(({ status, msg, data }) => {
        runInAction(() => {
          this.loginLoading = false;
          if (status) {
            if (data?.hasAccount !== false) {  //手机已绑定账号
              this.oneKeyLoginHasAccountCallback(data);
            } else {  //未绑定账号
              let confirm: any;
              prompt({
                title: getLabel('164050', '本机号码一键登录'),
                prompt: false,
                description: getLabel('229262', '本机号码当前无绑定账号，可选择注册新账号或绑定已有账号进行登录'),
                getInstance: (el: any) => {
                  confirm = el;
                },
                footer: [{
                  key: 'confirm',
                  text: getLabel('229263', '暂不绑定'),
                  onPress: () => {
                    confirm?.onClose?.();
                  }
                }, {
                  key: 'confirm',
                  text: getLabel('125610', '注册'),
                  type: 'primary',
                  onPress: () => {
                    window.location.href = `${publicUrl}/signup${window.location.search}`;
                    confirm?.onClose?.();
                  }
                }, {
                  key: 'confirm',
                  text: getLabel('229264', '绑定登录'),
                  type: 'primary',
                  onPress: () => {
                    beforeChangeBindAccount?.();
                    confirm?.onClose?.();
                    runInAction(() => {
                      this.bindMobileToken = data.bindMobileToken;
                    })
                  }
                }]
              })
            }
          } else {
            errorHandle(data?.errorMsg ? getLabel(data?.errorMsg?.i18nId, data?.errorMsg?.msg) : msg)
          }
        })
      }).catch((e) => {
        runInAction(() => {
          this.loginLoading = false;
        })
      })
    }).catch(() => {
      runInAction(() => {
        this.loginLoading = false;
      })
    });
  }

  oneKeyLoginHasAccountCallback = (data: any) => {
    if (data?.needQysCheck) {
      //开始契约锁认证
      this.onQysChecking = true;

      if (inApp()) {
        this.app_qysQueryParams = {
          authId: data.qysCheckAuthId,
          tenantKey: data.tenantKey,
          oneKeyLogin: true
        };
        this.app_qysLoginObj = this.mobileLoginObj;
        weappSDK.customSDK.invoke("openLink", {
          url: data.qysCheckAuthUrl,
          openType: 2,
        });
      } else {
        this.qysCheckLogin({
          authId: data.qysCheckAuthId,
          tenantKey: data.tenantKey
        }, this.mobileLoginObj);
        this.setQysFrameSrc(data.qysCheckAuthUrl);
      }
    } else if (!!data.needBindDevice) { //设备绑定
      this.needBindDeviceCallback?.();
      this.loginLoading = false;
      this.phoneOnKeyLoginDeviceBindToken = data.deviceBindToken;
      // this.phoneOnKeyLoginLoginData = params;
      this.dialogadviceVisible = true;
      window.sessionStorage.setItem('passport_thirdlogin_employeeId', data.employeeId + "");
      window.sessionStorage.setItem('passport_thirdlogin_thirdType', "oneKeyLogin");
      window.sessionStorage.setItem('passport_thirdlogin_openId', "none");
    } else if (!!data?.needPwdChange) {
      this.checkResetPass({ ...this.mobileLoginObj });
    } else {
      if (data.userIdToken) {
        setTokenStorage(data.userIdToken, "phoneNumber")
        setStorage("e_mobile_login_token", data.mobileLoginToken)
        window.sessionStorage.setItem('passport_sign_psw', this.mobileLoginObj.password);
        window.sessionStorage.setItem('passport_sign_account', this.mobileLoginObj.username || '');
        if (isEcologyEnv()) {
          this.ecToEteams();
          return;
        }
        this.toCreateTeams();
        return;
      }
      if (data.eteamsid != null && data.eteamsid != "") {
        let host = window.location.hostname;
        if (data.employeeId) {
          if (inApp()) {
            LoginAPI.checkLoginTeams({ ETEAMSID: data.eteamsid }).then((teamsData: any) => {
              if (teamsData.loginAccess === false) {
                weappSDK.customSDK.invoke("openLink", {
                  url: `${window.passport_runInfo.weappUrl}/mobile/obstruct/login?userIdToken=${data.userIdToken}`,
                  openType: 2
                })
              } else {
                weappSDK.register('login', (params: any) => {
                  weappSDK.customSDK.invoke('login', params)
                })
                weappSDK.exec("setItem", {
                  key: "loginFromLogout", // 存储的数据标识
                  value: "true",
                  isPublic: "0",//iOS用到，1登录后存储，0登录前存储
                }).then((res: any) => {
                });
                weappSDK.exec('login', {
                  loginkey: data.eteamsid,
                  tenantid: data.tenantkey,
                  userid: data.employeeId,
                  // username: this.mobileLoginObj.username,
                  // password: this.mobileLoginObj.password,
                  langid: data.langType,
                  cid: data.cid,
                  into: 1,
                }).then((res: any) => {
                  console.log(res)
                })
              }
            });
          } else {
            let service = this.getQueryString('service');
            if (service) {
              window.location.href = service;
            } else {
              window.location.href = `${mainHost()}${publicUrl}${data.redicretModuleSource ? `?redirectModuleSource=${data.redicretModuleSource}` : ``}`;
            }
          }
          this.loginLoading = false;
        }
      } else {
        this.loginLoading = false;
        this.onLoginError?.();
        toast({
          content: data.message,
          mask: false,
          delay: 1000
        });
      }
    }
  }

  @action
  onKeyLoginBindAccount = (loginParmas: loginParamsType) => {
    let bindAccountParams = {
      bindMobileToken: this.bindMobileToken,
      bindLoginAccount: loginParmas.username,
      bindLoginPassword: loginParmas.password,
      tenantKey: loginParmas.tenantKey
    };
    LoginAPI.onKeyLoginBindAccount(bindAccountParams).then(({ status, data, msg }) => {
      if (status) {
        if (data.mobileIsBind) {  //当前账号已经绑定手机号
          let confirm: any;
          prompt({
            title: getLabel('164050', '本机号码一键登录'),
            prompt: false,
            description: getLabel('229265', '当前输入账号已经有绑定的手机号码，请选择换绑或者重新输入账号'),
            getInstance: (el: any) => {
              confirm = el;
            },
            footer: [{
              key: 'exchange',
              type: 'primary',
              text: getLabel('229266', '换绑'),
              onPress: () => {
                confirm?.onClose?.();
                this.onKeyLoginChangeBindAccount(bindAccountParams, loginParmas)
              }
            }, {
              key: 'reform',
              text: getLabel('229267', '重新输入'),
              onPress: () => {
                confirm?.onClose?.();
              }
            }, {
              key: 'returnLogin',
              text: getLabel('93525', '返回登录'),
              onPress: () => {
                runInAction(() => {
                  this.bindMobileToken = "";
                })
                confirm?.onClose?.();
              }
            }]
          })
        } else if (data.hasTenant === false) {
          setTokenStorage(data.userIdToken, "phoneNumber");
          setStorage("e_mobile_login_token", data.mobileLoginToken)
          window.location.href = `${publicUrl}/signup/tenant`;
        } else {
          this.oneKeyLoginHasAccountCallback(data)
        }
      } else {
        toast({ type: "fail", content: data.errorMsg ? getLabel(data.errorMsg.i18nId, data.errorMsg.msg) : msg });
      }
    })
  }

  @action
  ecToEteams = () => {//ec无团队下跳eteams
    let confirm: any;
    this.loginLoading = false;
    prompt({
      title: getLabel('93425', '温馨提示'),
      prompt: false,
      message: getLabel('227055', '当前账号非e10私有化账号，请前往云端登录'),
      // getInstance: (el: any) => {
      //   confirm = el;
      // },
      mask: true,
      maskClosable: true,
      // message: "辅助信息类文字",
      // description: "说明性文字",
      onClose: () => {

      },
      onOk: () => {
        window.location.href = 'https://weapp.eteams.cn'
        confirm?.onClose?.();
      },
      okText: getLabel('93406', '确定'),
      cancelText: getLabel('93427', '取消'),
    })
  }

  @action
  onKeyLoginChangeBindAccount = (bindAccountParams: any, loginObj: any) => {
    LoginAPI.onKeyLoginChangeAccount({ ...bindAccountParams, changeBind: true }).then((response: any) => {
      if (response.status) {
        const result = response.data;
        if (result?.authUrl) {
          this.setQysFrameSrc(result.authUrl);
          this.qysCheckLogin({
            authId: result.authId,
            tenantKey: result.tenantKey
          }, {});
        } else if (result?.needPwdChange) {
          this.checkResetPass(loginObj);
        } else {
          if (result) {
            result.ETEAMSID = result.eteamsid;
            result.employeeid = result.employeeId;
            result.succeed = result.succeed ? "true" : "false"
            result.username = result.account
          }
          this.loginCallback(result, loginObj);
        }
      } else {
        if (response.data?.errorMsg) {
          toast({ type: "fail", content: getLabel(response.data?.errorMsg?.i18nId, response.data?.errorMsg?.msg) });
        }
      }
    })
  }

  @action
  loginCallback = (result: any, loginObj: any, notSaveLoginInfo?: boolean) => {
    runInAction(() => {
      if (result.userIdToken) {
        setTokenStorage(result.userIdToken)
        window.sessionStorage.setItem('passport_sign_psw', loginObj.password);
        window.sessionStorage.setItem('passport_sign_account', loginObj.username || '');
        if (isEcologyEnv()) {
          this.ecToEteams(); return;
        }
        this.toCreateTeams()
        return;
      }
      //一键登录情况接口兼容
      if (!result.ETEAMSID && result.eteamsid) {
        result.ETEAMSID = result.eteamsid;
      }
      if (result.succeed === true) {
        result.succeed = "true";
      }
      if (!result.employeeid && result.employeeId) {
        result.employeeid = result.employeeId;
      }

      if ("true" == result.succeed && (result.ETEAMSID != null && result.ETEAMSID != "")) {
        let host = window.location.hostname;
        let domain = host.substr(host.indexOf(".") + 1);
        // setCookie('ETEAMSID', result.ETEAMSID);
        // setCookie('ETEAMSID', result.ETEAMSID, domain);
        localStorage.setItem('activeLoginType', SkinStore?.activeLoginType)
        if (result.employeeid) {
          if (inApp()) {
            weappSDK.exec("setItem", {
              key: "activeLoginType", // 存储的数据标识
              value: SkinStore?.activeLoginType, // 存储的数据内容
              isPublic: "0",//iOS用到，1登录后存储，0登录前存储
            });
            // LoginAPI.checkLoginTeams({ETEAMSID: result.ETEAMSID, loginType: 'app_account'}).then((teamsData: any) => {
            LoginAPI.checkLoginTeams({ ETEAMSID: result.ETEAMSID }).then((teamsData: any) => {

              // try {
              //   weappSDK.ready(() => {
              //     if (weappSDK.customSDK.checkJsApi('setNativeLanguageType')) {
              //       weappSDK.customSDK.invoke("setNativeLanguageType", {
              //         locale: teamsData?.locale?.lang || '',
              //         success: (res: any) => {

              //自用系统外部联系人临时紧急控制
              if (isE10Self() && result.tenantkey === "t7akvdnf84" && teamsData.currentUser.type === "external") {
                toast({ type: "info", content: getLabel('252392', '当前用户没有权限登录') })
                return;
              }

              if (
                teamsData?.loginAccess === false ||
                teamsData?.firstLoginUpdatePassword === true ||
                teamsData?.forceUpdatePassword === true ||
                teamsData?.customLoginForbid === true
              ) {
                weappSDK.customSDK.invoke("openLink", {
                  url: `${window.passport_runInfo.weappUrl}/mobile/obstruct/login?userIdToken=${result.userIdToken}`,
                  openType: 2
                })
              } else {
                //TODO 跳转
                const { username, password } = loginObj;
                // document.cookie = `username=${username};`
                // document.cookie = `password=${password};`

                // weappSDK.invoke("clearWebCaches", {
                //   success: (res:any)=> {}
                // });
                weappSDK.register('login', (params: any) => {
                  weappSDK.customSDK.invoke('login', params)
                })

                weappSDK.exec("setItem", {
                  key: "loginFromLogout", // 存储的数据标识
                  value: "true",
                  isPublic: "0",//iOS用到，1登录后存储，0登录前存储
                }).then((res: any) => {
                });

                let loginParams = {
                  loginkey: result.ETEAMSID,
                  tenantid: result.tenantkey,
                  userid: result.employeeid,
                  ...(!notSaveLoginInfo ? {
                    username: result.username,
                    password: loginObj.password
                  } : {}),
                  langid: result.langType,
                  cid: result.cid,
                  into: 1,
                };
                if (window.ecode_passportAppLoginGetParams && typeof window.ecode_passportAppLoginGetParams === "function") {
                  loginParams = window.ecode_passportAppLoginGetParams(loginParams) || loginParams;
                }

                weappSDK.exec('login', loginParams).then((res: any) => {
                  console.log(res)
                })
              }
              // }
              //       })
              //     }
              //   })
              // } catch (error) {
              //   console.log(error)
              // }
            });
          } else {
            let service = this.getQueryString('service');
            if (service) {
              window.location.href = `${mainHost()}${publicUrlapi}/papi/baseserver/sso/secondDomainRedirect?eteamsid=${result.ETEAMSID}&service=${encodeURIComponent(service)}`
              // window.location.href = service;
            } else {
              if (result.redicretModuleSource) {
                window.location.href = `${mainHost()}${publicUrl}${result.redicretModuleSource ? `?redirectModuleSource=${result.redicretModuleSource}` : ``}`;
              } else {
                window.location.href = `${mainHost()}${publicUrlapi}/papi/baseserver/sso/secondDomainRedirect?eteamsid=${result.ETEAMSID}&service=${encodeURIComponent(window.passport_runInfo.weappUrl)}`
              }
            }
          }
          this.loginLoading = false;
        } else {
          if (result.userIdToken) {
            setTokenStorage(result.userIdToken)
          }

          window.sessionStorage.setItem('passport_sign_psw', loginObj.password);
          window.sessionStorage.setItem('passport_sign_account', result.account || '');
          this.loginLoading = false;
          if (isEcologyEnv()) {
            this.ecToEteams(); return;
          }
          this.toCreateTeams()
        }
      } else if (result.succeed === "false" && "true" == result.needBind) {
        this.loginLoading = false;
        this.dialogadviceVisible = true;
        window.sessionStorage.setItem('passport_sign_psw', loginObj.password);
        window.sessionStorage.setItem('passport_sign_account', loginObj.username || '');
        window.sessionStorage.setItem('passport_login_employeeId', result.employeeid + "");
      } else {
        // 0329
        // errorHandle(result.message);
        this.loginLoading = false;
        this.onLoginError?.();
        toast({
          content: result.message,
          mask: false,
          delay: 1000
        });
      }
    })
  }

  toCreateTeams = () => {
    let params = '';
    if (!getQueryString('wea_link_keep_customlogin') && isCustomLoginPath()){
      const customLoginKey = getCustomLoginKey();
      params = `?wea_link_keep_customlogin=${customLoginKey}`
    }
    window.location.href = `${publicUrl}/passport/teams${params}`;
  }

  @action
  getQueryString = (key: any) => {
    var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
  }
  //检查是否展示校验码
  @action
  checkVerifyCodeShow = (params: any, callback?: Function) => {
    return new Promise((resolve, reject) => {
      if (window.passport_runInfo.deployEnv !== 'private') {
        resolve(false);
      } else {
        LoginAPI.checkVerifyCodeShow(params)
          .then((result: any) => {
            runInAction(() => {
              if (result?.data?.safetyConfig?.verificationCode === 1) {
                if (!window.e_customPageData) { window.e_customPageData = {}; }
                window.e_customPageData.safetyConfig = { ...(window.e_customPageData.safetyConfig || {}), ...result?.data?.safetyConfig };
                callback && callback(result?.data);
                resolve(true)
              } else {
                callback && callback(false);
              }
              resolve(false)
            })
          })
          .catch((error) => {
            resolve(false)
          });
      }

    })
  }
  @action
  thirdAppLoginCallback(result: any) {
    if (result.eteamsid != null && result.eteamsid != "") {
      let host = window.location.hostname;
      let domain = host.substr(host.indexOf(".") + 1);
      // setCookie('ETEAMSID', result.eteamsid);
      // setCookie('ETEAMSID', result.eteamsid, domain);
      LoginAPI.clearWeappCookie().then(() => {

        if (result.employeeId) {
          LoginAPI.checkLoginTeams({ ETEAMSID: result.eteamsid }).then((teamsData: any) => {
            runInAction(() => {
              runInAction(() => {
                this.loginLoading = false;
              })
              if (teamsData.loginAccess === false) {
                weappSDK.customSDK.invoke("openLink", {
                  url: `${window.passport_runInfo.weappUrl}/mobile/obstruct/login?userIdToken=${result.userIdToken}`,
                  openType: 2
                })
              } else {
                weappSDK.register('login', (params: any) => {
                  weappSDK.customSDK.invoke('login', params)
                })
                weappSDK.exec('login', {
                  loginkey: result.eteamsid,
                  tenantid: result.tenantKey,
                  userid: result.employeeId,
                  username: result.account,
                  langid: result.langType,
                  cid: result.cid,
                  thirdLoginKey: result.tenantKey,  //单点登录标志
                  into: 1,
                }).then((res: any) => {
                  console.log(res)
                })
              }
            })
          }).catch(() => {
            runInAction(() => {
              this.loginLoading = false;
            })
          });
        } else {
          this.loginLoading = false;
        }
      })
    } else {
      this.loginLoading = false;
    }
  }

  @action
  appThirdSignLogin = (data: { signData: string, account: string, timestamp: string }) => {
    this.loginLoading = true;
    LoginAPI.signLogin(data).then((result) => {
      runInAction(() => {
        if (result.status) {
          this.thirdAppLoginCallback(result.data)
        } else {
          this.loginLoading = false;
          this.onLoginError?.();
          toast({
            content: result.msg || getLabel("151764", "单点登录失败，请使用账号密码登录")
          })
        }
      })
    }).catch(() => {
      runInAction(() => {
        this.loginLoading = false;
      })
    })
  }

  @action
  appThirdOpenLogin = (data: { appkey: string, appsecret: string, account: string }) => {
    this.loginLoading = true;
    LoginAPI.openApiLogin({
      appkey: data.appkey,
      appsecret: data.appsecret,
      account: data.account,
    }).then((result) => {
      runInAction(() => {
        if (result.status) {
          this.thirdAppLoginCallback(result.data);
        } else {
          this.loginLoading = false;
          this.onLoginError?.();
          toast({
            content: result.msg || getLabel("151764", "单点登录失败，请使用账号密码登录")
          })
        }
      })
    }).catch(() => {
      runInAction(() => {
        this.loginLoading = false;
      })
    })
  }

  @action
  updateLoginLoading(loading: boolean) {
    this.loginLoading = loading;
  }

  @action
  loadOneKeyLoginConfig = () => {
    LoginAPI.loadOneKeyLoginConfig(isIos() ? '2' : '1').then(({ status, data, msg }) => {
      runInAction(() => {
        if (status) {
          this.oneKeyLoginConfig = data;
        }
      })
    })
  }

  @action
  queryLogo = async () => {
    const res = await queryLogo(window.e_customPageData?.tenantKey);
    let hrefValue = dealImageUrl(res.data?.faviconUrl)

    if (hrefValue && hrefValue.indexOf("https://dl.eteams.cn/noauth") > -1) {
      hrefValue = hrefValue.replace("https://dl.eteams.cn/noauth", "https://weapp.eteams.cn/api/file/preview?fileId=");
    }

    if (hrefValue && hrefValue.indexOf("http://dl.eteams.cn/noauth") > -1) {
      hrefValue = hrefValue.replace("http://dl.eteams.cn/noauth", "https://weapp.eteams.cn/api/file/preview?fileId=");
    }
    document.querySelector('link[rel="icon"]')?.setAttribute('href', hrefValue);
  }

  @action
  cancelBindAccount = () => {
    this.bindMobileToken = "";
  }
}

const instance = new mLoginStore();

export default instance;
